export default function byTypename<Type extends { __typename: string }, Value extends string & Type["__typename"]>(
  lookingFor: Value,
): (value: Type) => value is Extract<Type, Record<"__typename", Value>> {
  return (value: Type): value is Extract<Type, Record<"__typename", Value>> => {
    return value.__typename === lookingFor;
  };
}
